import { Injectable } from '@angular/core';
import { WsACKCallback } from '@common/api/ack';
import { IID_FAULT_MANAGEMENT } from '@common/interfaces/interfaceData';
import { Topics } from '@common/interfaces/topics';
import { ActionService } from '../action/action.service';
import { CrudService } from '../crudService';
import { ProjectEntityStoreStrategy } from '../updateStoreStrategies';
import { IIDFaultManagementQuery } from './iidFaultManagement.query';
import { IIDFaultManagementStore } from './iidFaultManagement.store';
import { RealtimeFeatureCommandService } from '@ep-om/realtime-v2';
import { InterfaceDataService } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

@Injectable({
  providedIn: 'root'
})
@InterfaceDataService(InterfaceName.FAULT_MANAGEMENT)
export class IIDFaultManagementService extends CrudService<IID_FAULT_MANAGEMENT, IIDFaultManagementStore, IIDFaultManagementQuery> {

  constructor(
    protected store: IIDFaultManagementStore,
    public query: IIDFaultManagementQuery,
    protected actionService: ActionService,
    protected updateStrategy: ProjectEntityStoreStrategy,
    private featureCommandService: RealtimeFeatureCommandService,
  ) {
    super(
      Topics.IID_FAULT_MANAGEMENT,
      store,
      query,
      actionService,
      updateStrategy,
    );
  }

  sendFaultManagementToGisfo(id: string, callback?: WsACKCallback<void>) {
    const dto = { id };
    this.featureCommandService.send<void>(
      {
        target: 'feature:fault-management',
        command: 'send-to-gisfo',
        dto,
        ...this.projectIdFromEntity(id),
      },
      () => this.actionService.sendMessage(Topics.IID_FAULT_MANAGEMENT, 'sendFaultManagementToGisfo', dto, callback),
      callback,
    );
  }

  tryAgainSendFaultManagementToGisfo(id: string, callback?: WsACKCallback<void>) {
    const dto = { id };
    this.featureCommandService.send<void>(
      {
        target: 'feature:fault-management',
        command: 'retry-send-to-gisfo',
        dto,
        ...this.projectIdFromEntity(id),
      },
      () => this.actionService.sendMessage(Topics.IID_FAULT_MANAGEMENT, 'tryAgainSendFaultManagementToGisfo', dto, callback),
      callback,
    );
  }

  private projectIdFromEntity(id: string): { projectId?: string } {
    const projectId = this.query.getEntity(id)?.projectId;
    return projectId ? { projectId } : {};
  }
}
